import { render, staticRenderFns } from "./modalAddCategory.vue?vue&type=template&id=93511826&"
import script from "./modalAddCategory.vue?vue&type=script&lang=js&"
export * from "./modalAddCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports